import React from 'react';

const NationaIDModal = ({ modal, onChange, toggleModal, IdType, Country, IDNumber, modalOpen }) => {
  return (
    <>
      <div className={modal ? 'show' : 'hidden'}>
        <div
          ref={modalOpen}
          className="modal opacity-0 pointer-events-none w-full h-full top-0 left-0 flex items-center justify-center z-50"
        >
          <div className="absolute w-full h-full modal-overlay flex flex-wrap items-center">
            <div className="relative w-80 py-10 mx-auto bg-white rounded px-4 shadow">
              <div className="my-6">
                <h4 className="font-bold text-xl">Update your National ID</h4>
                <p>Make changes to your ID info here.</p>
              </div>

              <button
                className="absolute right-0 top-0 pr-6 pt-6 text-green-600 focus:outline-none"
                onClick={toggleModal}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-x"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>

              <form className="flex flex-wrap mt-4 justify-center items-center">
                <div className="w-1/2 pr-2 mb-4">
                  <input
                    type="text"
                    name="IdType"
                    id="IdType"
                    onChange={onChange}
                    value={IdType}
                    className="border-2 focus:outline-none border-gray-400 w-full px-2 py-2 rounded"
                  />
                </div>

                <div className="w-1/2 pl-2 mb-4">
                  <input
                    className="border-2 focus:outline-none border-gray-400 w-full px-2 py-2 rounded"
                    type="text"
                    name="Country"
                    id="Country"
                    onChange={onChange}
                    value={Country}
                  />
                </div>

                <div className="w-1/2 pr-2 mb-4">
                  <input
                    type="text"
                    name="IDNumber"
                    id="IDNumber"
                    onChange={onChange}
                    value={IDNumber}
                    className="border-2 focus:outline-none border-gray-400 w-full px-2 py-2 rounded"
                  />
                </div>

                <div className="w-1/2"></div>

                <div className="flex-row">
                  <button className="py-2 px-5 mr-2 bg-green-600 text-white text-base rounded focus:outline-none">
                    Save
                  </button>
                  <button className="py-2 px-4 text-base font-bold text-green-600 focus:outline-none">
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NationaIDModal;
